import { List, Typography } from 'antd';
import { ProductFeature } from '../../types/product';

const { Text, Paragraph } = Typography;

interface FeaturesSectionProps {
  features: ProductFeature[];
}

export function FeaturesSection({ features }: FeaturesSectionProps) {
  if (!features || features.length === 0) {
    return <Text type="secondary">No features available</Text>;
  }

  // Sort features by order number
  const sortedFeatures = [...features].sort((a, b) => a.ordernumber - b.ordernumber);

  return (
    <List
      dataSource={sortedFeatures}
      renderItem={(feature) => (
        <List.Item>
          <Paragraph style={{ margin: 0 }}>{feature.text}</Paragraph>
        </List.Item>
      )}
    />
  );
}
